// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared View button — used across Documents, Upload Inbox, and Dashboard
   queue. Icon-only 28×28 in the info-blue palette so every "View" the
   user sees looks identical regardless of the surface. */

.view-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid rgba(92, 124, 186, 0.3);
  border-radius: 6px;
  background: var(--color-surface-light, #fff);
  color: var(--color-info, #5c7cba);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  flex-shrink: 0;
}

.view-btn:hover:not(:disabled) {
  background: rgba(92, 124, 186, 0.08);
  border-color: var(--color-info, #5c7cba);
}

.view-btn:focus-visible {
  outline: 2px solid var(--color-info, #5c7cba);
  outline-offset: 2px;
}

.view-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.view-btn svg {
  flex-shrink: 0;
}

/* Mobile — bump to touch-target size so it's tappable in stacked-card
   layouts on every surface. */
@media (max-width: 767px) {
  .view-btn {
    width: var(--touch-target-min, 44px);
    height: var(--touch-target-min, 44px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ViewButton.css"],"names":[],"mappings":"AAAA;;yDAEyD;;AAEzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yCAAyC;EACzC,kBAAkB;EAClB,4CAA4C;EAC5C,iCAAiC;EACjC,eAAe;EACf,4EAA4E;EAC5E,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;8BAC8B;AAC9B;EACE;IACE,oCAAoC;IACpC,qCAAqC;EACvC;AACF","sourcesContent":["/* Shared View button — used across Documents, Upload Inbox, and Dashboard\n   queue. Icon-only 28×28 in the info-blue palette so every \"View\" the\n   user sees looks identical regardless of the surface. */\n\n.view-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 1px solid rgba(92, 124, 186, 0.3);\n  border-radius: 6px;\n  background: var(--color-surface-light, #fff);\n  color: var(--color-info, #5c7cba);\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.view-btn:hover:not(:disabled) {\n  background: rgba(92, 124, 186, 0.08);\n  border-color: var(--color-info, #5c7cba);\n}\n\n.view-btn:focus-visible {\n  outline: 2px solid var(--color-info, #5c7cba);\n  outline-offset: 2px;\n}\n\n.view-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.view-btn svg {\n  flex-shrink: 0;\n}\n\n/* Mobile — bump to touch-target size so it's tappable in stacked-card\n   layouts on every surface. */\n@media (max-width: 767px) {\n  .view-btn {\n    width: var(--touch-target-min, 44px);\n    height: var(--touch-target-min, 44px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
